import { createContext } from "react";

const TrainingCentreRegContext = createContext();

const tableCustomization = {
  selectableRows: 'none',
  search: false,
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  pagination: false,
}


function handleSelectSkillsTaughtAtCentre(event, dispatch) {
  dispatch({
    type: "selectedSkillsTaughtAtCentre",
    body: event.target.value,
  });
}

function handleTextFieldChanges(type, body, dispatch) {
  dispatch({
    type: type,
    body: body,
  });
}

export {
  handleSelectSkillsTaughtAtCentre,
  handleTextFieldChanges,
  TrainingCentreRegContext,
  tableCustomization,
}